import { PureComponent, Fragment } from 'react';
import uuid from 'uuid';

import Icon from 'components/Icon';

export default class Checkbox extends PureComponent {
  state = { checked: this.props.checked || false };

  id = uuid();

  handleCheckboxRef = ref => {
    this.node = ref;
  };

  onChange = () => {
    this.setState({ checked: this.node.checked });
    this.props.onChange &&
      this.props.onChange({
        key: this.node.name,
        value: this.node.checked,
      });
  };

  render() {
    const {
      className = '',
      staticClass = 'checkbox__wrap',
      name = 'checkbox',
      text = 'Remember me',
      error,
    } = this.props;

    return (
      <Fragment>
        <div className={cx(staticClass, className)}>
          <input
            checked={this.state.checked}
            className="checkbox__input"
            id={this.id}
            name={name}
            onChange={this.onChange}
            type="checkbox"
            ref={this.handleCheckboxRef}
          />
          <label htmlFor={this.id} className="checkbox__label">
            <div className="checkbox__faces">
              <div className="checkbox__icon">
                <Icon icon="check" />
              </div>
            </div>
            <div className="checkbox__text">{text}</div>
          </label>
          {error && <div className="input-error-text">{error}</div>}
        </div>
      </Fragment>
    );
  }
}
